import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const base_url = `${environment.base_url}/Municipios`;

@Injectable({
   providedIn: 'root'
})
export class MunicipiosService {

   token: string = localStorage.getItem('tp-Token') || '';
   headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Tp-Token': localStorage.getItem('tp-Token') || ''
   });

   constructor(
      private http: HttpClient,
   ) { }

   busqueda(valor: string, pagina: number, rows: number) {
      const url = `${base_url}/getBusquedaMunicipio/${valor}?page=${pagina}&rows=${rows}`;

      return this.http.get(url, { headers: this.headers })
         .pipe(
            map(
               (resp: any) => {
                  const respuesta = { status: resp.status, totalPaginas: resp.totalPaginas, detalle: resp.detalle };
                  return respuesta;
               }
            )
         )
         ;
   }

   getMunicipioId(id: number) {
      const url = `${base_url}/getMunicipioId/${id}`;

      return this.http.get(url, { headers: this.headers })
         .pipe(
            map(
               (resp: any) => {
                  const respuesta = { status: resp.status, totalPaginas: resp.totalPaginas, detalle: resp.detalle };
                  return respuesta;
               }
            )
         )
         ;
   }

   getAll(pagina: number, rows: number, desdeProvincia: string, hastaProvincia: string, orden: string, desc: number) {
      const url = `${base_url}/getAll?page=${pagina}&rows=${rows}&depro=${desdeProvincia}&hapro=${hastaProvincia
         }&order=${orden}&desc=${desc}`;
      // console.log(url);

      return this.http.get(url, { headers: this.headers })
         .pipe(
            map(
               (resp: any) => {
                  // console.log(resp);
                  const respuesta = { status: resp.status, totalPaginas: resp.totalPaginas, detalle: resp.detalle };

                  return respuesta;
               }
            )
         )
         ;
   }


}
